module.exports = Object.freeze({
  MODAL_BODY_TYPES : {
    USER_DETAIL : "USER_DETAIL",
    LEAD_ADD_NEW : "LEAD_ADD_NEW",
    MESSAGE_ADD_NEW : "MESSAGE_ADD_NEW",
    BULLETIN_ADD_NEW : "BULLETIN_ADD_NEW",
    MESSAGE_EDIT : "MESSAGE_EDIT",
    MESSAGE_DELETE : "MESSAGE_DELETE",
    BULLETIN_DELETE : "BULLETIN_DELETE",
    IMPORT_FROM_CSV : "IMPORT_FROM_CSV",
    SPECIAL_MESSAGE_ADD_NEW : "SPECIAL_MESSAGE_ADD_NEW",
    SPECIAL_MESSAGE_EDIT : "SPECIAL_MESSAGE_EDIT",
    SPECIAL_MESSAGE_DELETE : "SPECIAL_MESSAGE_DELETE",
    SPECIAL_IMPORT_FROM_CSV : "SPECIAL_IMPORT_FROM_CSV",
    SPECIAL_MEETING_ADD_NEW : "SPECIAL_MEETING_ADD_NEW",
    SPECIAL_MEETING_IMPORT_FROM_CSV : "SPECIAL_MEETING_IMPORT_FROM_CSV",
    SPECIAL_MEETING_DELETE : "SPECIAL_MEETING_DELETE",
    SCHEDULE_ADD_NEW : "SCHEDULE_ADD_NEW",
    SCHEDULE_EDIT : "SCHEDULE_EDIT",
    SCHEDULE_DELETE : "SCHEDULE_DELETE",
    SERVICE_ROLE_ADD_NEW : "SERVICE_ROLE_ADD_NEW",
    SERVICE_ROLE_EDIT : "SERVICE_ROLE_EDIT",
    SERVICE_ROLE_DELETE : "SERVICE_ROLE_DELETE",
    CONFIRMATION : "CONFIRMATION",
    DEFAULT : "",
  },

  RIGHT_DRAWER_TYPES: {
    NOTIFICATION: "NOTIFICATION",
    CALENDAR_EVENTS: "CALENDAR_EVENTS",
  },

  CONFIRMATION_MODAL_CLOSE_TYPES: {
    LEAD_DELETE: "LEAD_DELETE",
  },
});
